import { useEffect, useRef, useState } from "react";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*";

function randomChar() {
  return CHARS[Math.floor(Math.random() * CHARS.length)];
}

export function ScrambleText({ texts, interval = 4000, className }) {
  const [display, setDisplay] = useState(texts[0]);
  const indexRef = useRef(0);

  useEffect(() => {
    const scramble = (target) => {
      const len = Math.max(display.length, target.length);
      let frame = 0;
      const totalFrames = 10;

      const id = setInterval(() => {
        frame++;
        let result = "";
        for (let i = 0; i < len; i++) {
          if (i >= target.length) {
            // Shrink: show random then disappear
            result += frame > totalFrames / 2 ? "" : randomChar();
          } else if (frame >= totalFrames - (len - 1 - i)) {
            // Resolve from left to right
            result += target[i];
          } else {
            result += randomChar();
          }
        }
        setDisplay(result);
        if (frame >= totalFrames) clearInterval(id);
      }, 40);
    };

    const timer = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % texts.length;
      scramble(texts[indexRef.current]);
    }, interval);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [texts, interval]);

  return <span className={className}>{display}</span>;
}
